import { Col } from "antd";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { appTitle } from "./common/GeneralConfigurations";
import AdnLogo from "../assets/images/logo_sem_adentis.png";
import { AppRoutes } from "../AppRoutes";

const ForbiddenPage = () => {
  useEffect(() => {
    document.title = `${appTitle} - Forbidden`;
  }, []);
  const navigate = useNavigate();

  return (
    <>
      <div id="main">
        <div
          className="text-center"
          style={{
            justifyContent: "center",
            alignItems: "center",
            marginTop: "75px",
          }}
        >
          <Col className="important d-none d-sm-block">
            <img
              src={AdnLogo}
              fluid
              className="full"
              style={{cursor: "pointer"}}
              height="260"
              alt="logo"
              onClick={() => navigate(AppRoutes.home.path)}
            />
          </Col>
          <h1>Forbidden</h1>
          <h6>Access to this resource is denied.</h6>
        </div>
      </div>
    </>
  );
};

export default ForbiddenPage;
